import styled from "styled-components";

export const Logo = styled.img`
  height: 14rem;
`;
